module.exports = __webpack_public_path__ + "img/ConstructionQuality.f2f60b6d.svg";